// Replicates the legacy signin_form.js SAML hand-off: fetch the saml_login GET
// page, lift its hidden inputs into a hidden form on the current page, and
// submit that form via POST. allauth refuses the SAML redirect on GET for
// security reasons (https://docs.allauth.org/en/dev/release-notes/2021.html).

const SAML_FORM_ID = 'saml_login_redirect_form';

function ensureRedirectForm() {
  let form = document.getElementById(SAML_FORM_ID);
  if (form === null) {
    form = document.createElement('form');
    form.id = SAML_FORM_ID;
    form.method = 'post';
    form.style.display = 'none';
    document.body.appendChild(form);
  }
  return form;
}

export function lookupSsoDomain(email, emailDomains) {
  if (!email || typeof email !== 'string') return null;
  const at = email.indexOf('@');
  if (at < 0) return null;
  const domain = email.slice(at + 1).trim().toLowerCase();
  if (!domain) return null;
  return emailDomains?.[domain] || null;
}

export async function redirectToSamlLogin(redirectUrl) {
  const response = await fetch(redirectUrl, {method: 'GET', credentials: 'include'}),
        html = await response.text(),
        parsed = new DOMParser().parseFromString(html, 'text/html'),
        form = ensureRedirectForm();
  form.innerHTML = '';
  parsed.querySelectorAll('input[type="hidden"]').forEach((input) => {
    const clone = document.createElement('input');
    clone.type = 'hidden';
    clone.name = input.getAttribute('name') || '';
    clone.value = input.getAttribute('value') || '';
    form.appendChild(clone);
  });
  form.action = redirectUrl;
  form.submit();
}
